import { AlertEnum, ButtonVariantEnum } from '../../enums';
import { Button, ItemCard } from '../../components';
import { CandidaturaResponseType, CandidaturasGerenciamentoCardListType } from '../../types';
import { IconHandler, ImageHandler } from '../../utils';
import { useAlert, useAuthAxios, useErrorHandler, useForceReRender, useModal } from '../../hooks';

import { ApiHelper } from '../../helpers';
import { FaUserTie } from 'react-icons/fa';
import { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';

const CandidaturasGerenciamentoCardList: FunctionComponent<CandidaturasGerenciamentoCardListType> = ({
  idEleicao,
  idCargo,
  candidaturas,
}) => {
  const { t } = useTranslation();
  const { createAlert } = useAlert();
  const errorHandler = useErrorHandler();
  const { forceReRender } = useForceReRender();
  const { confirmModal } = useModal();
  const axios = useAuthAxios();

  return (
    <div className="row row-cols-1 row-cols-lg-2 g-2">
      {candidaturas?.length > 0 ? (
        candidaturas.map((candidatura: CandidaturaResponseType) => (
          <div className="col" key={candidatura.id}>
            <ItemCard
              ImageSection={
                <>
                  <ImageHandler
                    src={candidatura.foto.link}
                    alt={t('descricao_objeto.img_candidato', { nome_chapa: candidatura.nome_chapa })}
                    className="img-candidato-small img-frame m-1 ms-2"
                  />
                  <ImageHandler
                    src={candidatura.foto_vice ? candidatura.foto_vice.link : ''}
                    alt={t('descricao_objeto.img_vice_candidato', { nome_chapa: candidatura.nome_chapa })}
                    className="img-candidato-small img-frame m-1 me-2"
                    noImageTitle={t('label.vice_sem_imagem')}
                  />
                </>
              }
              header={`${candidatura.nome_chapa} #${candidatura.numero_chapa.toString().padStart(2, '0')}`}
              footer={
                <Button
                  className="justify-content-center p-1"
                  title={t('label.remover_candidatura')}
                  variant={ButtonVariantEnum.LINK_DANGER}
                  onClick={() => {
                    confirmModal(
                      t('confirmacao.remover_candidatura', {
                        nome_chapa: candidatura.nome_chapa,
                        numero_chapa: candidatura.numero_chapa.toString().padStart(2, '0'),
                      }),
                      () => {
                        axios
                          .delete(ApiHelper.getUrl.apiSCE.candidatura(idEleicao, idCargo, candidatura.id))
                          .then((response) => {
                            forceReRender();
                            createAlert(t('sucesso.remover_candidatura'), AlertEnum.SUCCESS);
                          })
                          .catch((error) => errorHandler(error, t('erro.remover_candidatura')));
                      },
                      ButtonVariantEnum.DANGER,
                      t('label.remover_candidatura'),
                    );
                  }}
                >
                  {t('label.remover_candidatura')}
                </Button>
              }
            >
              <div className={'d-flex justify-content-start'}>{candidatura.descricao}</div>
            </ItemCard>
          </div>
        ))
      ) : (
        <div className="empty-body-card text-center p-2">
          <IconHandler Icon={FaUserTie}></IconHandler>
          <span className="text-muted">{t('texto.nenhuma_candidatura_cadastrada')}</span>
        </div>
      )}
    </div>
  );
};

export default CandidaturasGerenciamentoCardList;
